
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-a-demo",
      function () {
        return require("private-next-pages/book-a-demo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-a-demo"])
      });
    }
  